import React from 'react';
import { CarouselUI } from './ui';
export const Carousel = ({ children, onChange, constrolsOnHorizontal, constrolsOnVertical, slideToShow, id, header, onNextSlideClick, onPrevSlideClick, }) => {
    return (React.createElement(CarouselUI, { id: id, onChange: i => onChange && onChange(i), constrolsOnHorizontal: constrolsOnHorizontal, constrolsOnVertical: constrolsOnVertical, slideToShow: slideToShow, header: header, onNextSlideClick: onNextSlideClick, onPrevSlideClick: onPrevSlideClick }, children));
};
Carousel.defaultProps = {
    slideToShow: 1,
};
//# sourceMappingURL=index.js.map